import servicesUtils from "../../../utils/servicesUtils";
import { useQuery } from "react-query";
var useGetMeetingsList = function useGetMeetingsList() {
  return useQuery(["meetingsList"], function () {
    return servicesUtils.getService("/recordings");
  });
};
export default useGetMeetingsList;